import {
  BiRelativeTimePreset,
  BiRollingTimeRange,
  BiTimeGrain,
  BiTimeRange,
  BiTimeRangeKind,
} from '@euler/model/bi/query';
import dayjs from 'dayjs';

const kPresetLabels: Record<BiRelativeTimePreset, string> = {
  [BiRelativeTimePreset.Today]: '今天',
  [BiRelativeTimePreset.Yesterday]: '昨天',
  [BiRelativeTimePreset.Last7Days]: '近7天',
  [BiRelativeTimePreset.Last30Days]: '近30天',
  [BiRelativeTimePreset.Last90Days]: '近90天',
  [BiRelativeTimePreset.Last12Months]: '近12个月',
  [BiRelativeTimePreset.ThisWeek]: '本周',
  [BiRelativeTimePreset.LastWeek]: '上周',
  [BiRelativeTimePreset.ThisMonth]: '本月',
  [BiRelativeTimePreset.LastMonth]: '上月',
  [BiRelativeTimePreset.ThisQuarter]: '本季度',
  [BiRelativeTimePreset.LastQuarter]: '上季度',
  [BiRelativeTimePreset.ThisYear]: '今年',
  [BiRelativeTimePreset.LastYear]: '去年',
};

/** No dashboard range: each card keeps its own time range. */
export const kBiCardOwnRangeLabel = '各图表默认';

/** How "N of a unit" reads: `3 个月`, `2 个季度`, `7 天`. */
export const kBiRollingUnitLabels: Record<BiTimeGrain, string> = {
  [BiTimeGrain.Day]: '天',
  [BiTimeGrain.Week]: '周',
  [BiTimeGrain.Month]: '个月',
  [BiTimeGrain.Quarter]: '个季度',
  [BiTimeGrain.Year]: '年',
};

/** `最近3个月（含本期）`: the period as the user said it. */
export function biRollingLabel(range: BiRollingTimeRange): string {
  return `最近${range.count}${kBiRollingUnitLabels[range.unit]}${
    range.includeCurrent ? '（含本期）' : '（不含本期）'
  }`;
}

export function biTimeRangeLabel(range: BiTimeRange | undefined): string {
  if (!range) return kBiCardOwnRangeLabel;
  if (range.kind === BiTimeRangeKind.Relative)
    return kPresetLabels[range.preset] ?? range.preset;
  if (range.kind === BiTimeRangeKind.Rolling) return biRollingLabel(range);
  const format = (value: string) => dayjs(value).format('YYYY年M月D日');
  return `${format(range.from)} – ${format(range.to)}`;
}
